import './polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import pkg from '../package.json'

// import { setContext } from 'apollo-link-context'
// import ApolloClient from 'apollo-client'
// import { HttpLink } from 'apollo-link-http'
// import { InMemoryCache } from 'apollo-cache-inmemory'
import { ApolloClient, InMemoryCache, HttpLink, ApolloLink, concat, ApolloProvider } from '@apollo/client';
const cache = new InMemoryCache();


// disable ServiceWorker
// import registerServiceWorker from './registerServiceWorker';

const httpLink = new HttpLink({
  uri: process.env.REACT_APP_API_URI,
  headers: {
    "skip-cache-get": "true"
  },
})

const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  const token = localStorage.getItem('access_token')
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ''
    }
  }));

  return forward(operation);
})

// const authLink = setContext((_, { headers = {} }) => {
//   const token = localStorage.getItem('access_token')

//   return {
//     headers: {
//       ...headers,
//       authorization: token ? `Bearer ${token}` : ''
//     }
//   }
// })

const client = new ApolloClient({
  link: concat(authMiddleware, httpLink),
  cache,
  name: "onezone-admin",
  version: pkg.version
})

console.log(pkg.version)

const render = Component => {
  ReactDOM.render(
    <ApolloProvider client={client}>
      <Component />
    </ApolloProvider>,
    document.getElementById('root')
  )
}

render(App)
// disable ServiceWorker
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js